import { ReactNode, createContext, useContext, useMemo } from 'react';
import { IRecommendedActionWithState } from 'components/recommended-actions/useRecommendedActionsData';

interface IRecommendedActionContext {
    variant: 'primary' | 'secondary';
    action: IRecommendedActionWithState;
}

const RecommendedActionContext = createContext<IRecommendedActionContext | undefined>(undefined);

const useRecommendedActionContext = () => {
    const context = useContext(RecommendedActionContext);
    if (!context) {
        throw new Error(
            'useRecommendedActionContext must be used within a RecommendedActionProvider',
        );
    }
    return context;
};

const RecommendedActionProvider = ({
    variant,
    action,
    children,
}: { children: ReactNode } & IRecommendedActionContext) => {
    const value = useMemo(
        () => ({
            variant,
            action,
        }),
        [variant, action],
    );
    return (
        <RecommendedActionContext.Provider value={value}>
            {children}
        </RecommendedActionContext.Provider>
    );
};

export { useRecommendedActionContext, RecommendedActionProvider };

export type { IRecommendedActionContext };
